import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';

const ComponentAdd = () => {
  const toast = useRef(null);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [supllierlist,setSupllierlist] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    component: "",
    componentSkuCode: "",
    componentType: "",
    description: "",
    supplier: "",
    cost: "",
    stockLevel: "",
    freightCharges: "",
    unitOfMeasurement: "",
    superdrugSkuCode: "",
    notes: "",
    supplier_cost:""
  });


  useEffect(()=>{
    getunits();
    getsupplier();
    getcurrency();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.component) newErrors.component = "Component is required";
    if (!formData.componentSkuCode) newErrors.componentSkuCode = "SKU Code is required";
    if (!formData.cost || isNaN(formData.cost)) newErrors.cost = "Valid cost is required";
    if (!formData.stockLevel || isNaN(formData.stockLevel)) newErrors.stockLevel = "Valid stock level is required";
    if (!formData.unitOfMeasurement) newErrors.unitOfMeasurement = "Unit is required";
    if (!formData.componentType) newErrors.componentType = "Component Type is required";
    if (!formData.supplier) newErrors.supplier = "Supplier is required";
    // if (!formData.freightCharges) newErrors.freightCharges = "FreightCharges is required";
    // if (!formData.superdrugSkuCode) newErrors.superdrugSkuCode = "SuperdrugSkuCode is required";
    // if (!formData.supplier_cost) newErrors.supplier_cost = "Supplier Cost is required";

    // Add other field validations as needed

    return newErrors;
  };

  const refs = {
    component: useRef(null),
    componentSkuCode: useRef(null),
    cost: useRef(null),
    stockLevel: useRef(null),
    unitOfMeasurement: useRef(null),
    componentType: useRef(null),
    supplier: useRef(null),
    freightCharges: useRef(null),
    superdrugSkuCode: useRef(null),
    supplier_cost: useRef(null),
  };

  const handlesubmit = (e) => {
     e.preventDefault();
        const validationErrors = validate();
          setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
      // Focus first input with error
          const firstErrorKey = Object.keys(validationErrors)[0];
          if (refs[firstErrorKey]) {
            refs[firstErrorKey].current.focus();
          }
      return;
    }
    setLoading(true);
        productservices.createcomponent(formData).then((response)=>{
            if(response.status == 200){
                //  console.log€0
                setLoading(false);
                toast.current.show({ severity: 'success', summary: 'Component', detail: 'Component created successfully' }); 
            }else{
              setLoading(false);
                toast.current.show({ severity: 'error', summary: 'Component', detail: `${response.data.data}` }); 
            }   
        }).catch((error)=>{
          setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Component', detail: 'Error' }); 
        });
    

    // Handle form submission here
  };

  const getunits = () =>{
    unitreducer.then((response)=>{
        //  console.log(response);
         setUnits(response);
      }).catch((error)=>{
          
      });
  }
  const getsupplier = () =>{
    supplierservices.getallsupllier().then((response)=>{
      console.warn(response);
        if(response.status ==200){
            setSupllierlist(response.data.data);  
        }else{
            setSupllierlist([]); 
        }
         
      }).catch((error)=>{
            setSupllierlist([]); 
      });
  }
  const handleClose = () => {
    // Handle close action here
  };

  function displaySupplier(){
    let unitsarr = [];
    units.forEach((value,index)=>{
      unitsarr.push(<option value={value.short_code}>{value.name}</option>); 
    });

    return unitsarr;
  }
    function displaySupplier2(){
      let supllierdata = [];
      supllierlist.forEach((value,index)=>{
        supllierdata.push(<option value={value.id}>{value.name}</option>); 
      });
      return supllierdata;
   }

   const getcurrency = () => {
    currencyreducer.then((response)=>{
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

   const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Component / Createcomponent"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Create Component"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>
                  <div className="row">
                    {/* Component Name */}
                    <div className="col-md-6 form-group">
                      <label>Component</label>
                      <input
                        type="text"
                        name="component"
                        className="form-control"
                        placeholder="Enter Component Name"
                        value={formData.component}
                        onChange={handleChange}
                        ref={refs.component}
                      />
                    {errors.component && <span style={{ color: "red" }}>{errors.component}</span>}
                    </div>

                    {/* Component SKU Code */}
                    <div className="col-md-6 form-group">
                      <label>Component SKU Code</label>
                      <input
                        type="text"
                        name="componentSkuCode"
                        className="form-control"
                        placeholder="Enter Component SKU Code"
                        value={formData.componentSkuCode}
                        onChange={handleChange}
                        ref={refs.componentSkuCode}
                      />
                      {errors.componentSkuCode && <span style={{ color: "red" }}>{errors.componentSkuCode}</span>}
                    </div>

                    {/* Component Type */}
                    <div className="col-md-6 form-group">
                      <label>Component Type</label>
                      <select
                        name="componentType"
                        className="form-control"
                        value={formData.componentType}
                        onChange={handleChange}
                        ref={refs.componentType}
                      >
                        <option value="">Select Component Type</option>
                        <option value="normal">Normal</option>
                        <option value="freeissue">Free issue Ingredient</option>
                      </select>
                       {errors.componentType && <span style={{ color: "red" }}>{errors.componentType}</span>}
                    </div>

                    {/* Description */}
                    <div className="col-md-6 form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control"
                        placeholder="Enter Description (e.g., Bottle, Label)"
                        value={formData.description}
                        onChange={handleChange}
                        ref={refs.description}
                      />
                      {errors.description && <span style={{ color: "red" }}>{errors.description}</span>}
                    </div>

                    {/* Supplier */}
                    <div className="col-md-6 form-group">
                      <label>Supplier</label>
                      <select
                        name="supplier"
                        className="form-control"
                        value={formData.supplier}
                        onChange={handleChange}
                        ref={refs.supplier}
                      >
                        <option value="">Select Supplier</option>
                         {displaySupplier2()}
                      </select>
                      {errors.supplier && <span style={{ color: "red" }}>{errors.supplier}</span>}
                    </div>

                    {/* Cost */}
                    <div className="col-md-6 form-group">
                      <label>Cost</label>
                      <div className="flex-box">
                            <select className="form-control" name="cost_currency" style={{width:'60px'}} onChange={handleChange}>
                               {displayCurrency()}
                            </select>
                            <input
                            type="number"
                            name="cost"
                            className="form-control"
                            placeholder="Enter Cost"
                            value={formData.cost}
                            onChange={handleChange}
                            ref={refs.cost}
                          />
                           
                      </div>  
                      {errors.cost && <span style={{ color: "red" }}>{errors.cost}</span>}   
                    </div>

                    {/* Stock Level */}
                    <div className="col-md-6 form-group">
                      <label>Stock Level</label>
                      <input
                        type="number"
                        name="stockLevel"
                        className="form-control"
                        placeholder="Enter Stock Level"
                        value={formData.stockLevel}
                        onChange={handleChange}
                        ref={refs.stockLevel}
                      />
                      {errors.stockLevel && <span style={{ color: "red" }}>{errors.stockLevel}</span>}
                    </div>

                    {/* Freight Charges */}
                    <div className="col-md-6 form-group">
                      <label>Freight Charges</label>
                      <input
                        type="text"
                        name="freightCharges"
                        className="form-control"
                        placeholder="Enter Freight Charges"
                        value={formData.freightCharges}
                        onChange={handleChange}
                        ref={refs.freightCharges}
                      />
                       {errors.freightCharges && <span style={{ color: "red" }}>{errors.freightCharges}</span>}
                    </div>

                    {/* Unit of Measurement */}
                    <div className="col-md-6 form-group">
                      <label>Unit of Measurement</label>
                      <select
                        name="unitOfMeasurement"
                        className="form-control"
                        value={formData.unitOfMeasurement}
                        onChange={handleChange}
                        ref={refs.unitOfMeasurement}
                      >
                        <option value="">Select Unit of Measurement</option>
                        {displaySupplier()}
                      </select>
                      {errors.unitOfMeasurement && <span style={{ color: "red" }}>{errors.unitOfMeasurement}</span>}
                    </div>

                    {/* Superdrug SKU Code */}
                    <div className="col-md-6 form-group">
                      <label>Superdrug SKU Code</label>
                      <input
                        type="text"
                        name="superdrugSkuCode"
                        className="form-control"
                        placeholder="Enter Superdrug SKU Code"
                        value={formData.superdrugSkuCode}
                        onChange={handleChange}
                        ref={refs.superdrugSkuCode}
                      />
                      {/* {errors.superdrugSkuCode && <span style={{ color: "red" }}>{errors.superdrugSkuCode}</span>} */}
                    </div>

                    {/* Notes (Full Width) */}
                    <div className="col-md-12 form-group">
                      <label>Notes</label>
                      <textarea
                        name="notes"
                        className="form-control"
                        placeholder="Enter Note"
                        value={formData.notes}
                        onChange={handleChange}

                      ></textarea>
                    </div>

                    <div className="col-md-6 form-group">
                      <div className="row">
                        <div className="col-md-12">
                          <label>Supplier Cost</label>
                          <div className="flex-box">
                             <select className="form-control" name="supplier_currency" style={{width:'60px'}} onChange={handleChange}>
                               {displayCurrency()}
                            </select>
                            <input
                            type="text"
                            name="supplier_cost"
                            className="form-control"
                            placeholder="Enter Supplier Cost"
                            value={formData.supplier_cost}
                            onChange={handleChange}
                            ref={refs.supplier_cost}
                          />
                          
                          </div>
                        {errors.supplier_cost && <span style={{ color: "red" }}>{errors.supplier_cost}</span>}
                        </div>

                       
                      </div>
                    </div>
                  </div>

                  <br></br>
                  <br></br>
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                         disabled={loading}
                        // onClick={handleSave}
                      >
                       {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Loading...
                                    </>
                                ) : (
                                    "Upload"
                                )}
                      </button>
                    </div>

                    <div className="col-md-6">
                      <button
                        type="button"
                        className="btn color-white w-100 rounded custom-btn-color-secondary"
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComponentAdd;
